import request from '@/utils/request';
import {
  FreezeAuthToPayParams,
  SettlementExpectedRevenueQuery,
  SettlementExpectedRevenueResult,
  SettlementListResult,
  SettlementOverdueResponse,
  SettlementQueryParams,
} from '@/types/finance';

export const financeService = {
  getSettlements: async (params: any): Promise<SettlementListResult> => {
    const response = await request.get<SettlementListResult>('/api/admin/finance/settlement', {params});
    return response;
  },

  getExpectedRevenue: async (params: SettlementExpectedRevenueQuery): Promise<SettlementExpectedRevenueResult> => {
    const response = await request.get<SettlementExpectedRevenueResult>(
      '/api/admin/finance/settlement/expected-revenue',
      { params },
    );
    return response;
  },

  freezeAuthToPay: async (params: FreezeAuthToPayParams) => {
    const response = await request.post('/api/admin/finance/settlement/freeze-auth-to-pay', params);
    return response;
  },

  confirmOfflineRepDeposit: async (id: number) => {
    const response = await request.post('/api/admin/orders/confirm-offline-rep-deposit', { id });
    return response;
  },

  getOverdueDetails: async (params: SettlementQueryParams): Promise<SettlementOverdueResponse> => {
    const response = await request.get<SettlementOverdueResponse>('/api/admin/finance/settlement/overdue-record', { params });
    return response;
  },

  // 导出结算记录
  exportSettlements: async (params: any): Promise<void> => {
    const response = await request.get<Blob>('/api/admin/finance/settlement/export', {
      params,
      responseType: 'blob',
    });

    const blob = response instanceof Blob ? response : new Blob([response]);

    if (blob.type.includes('json')) {
      const text = await blob.text();
      let errorMessage = '导出失败';
      try {
        const json = JSON.parse(text) as { message?: string };
        if (json.message) {
          errorMessage = json.message;
        }
      } catch {
        // 非 JSON 响应，使用默认文案
      }
      throw new Error(errorMessage);
    }

    const downloadBlob = new Blob([blob], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(downloadBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `结算记录_${new Date().getTime()}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};

